import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';
import {getStatus} from '../../../../../../@casino/lib/getStatus';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        paddingTop: 0, 
        color: '#fff'
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: '97.3%'
    }
}));


const columns = [
    { id: 'id', label: 'ID'},
    { id: 'dates', label: 'Дата'},
    { id: 'login', label: 'Логин пользвателя'},
    { id: 'description', label: 'Описание'},
    { id: 'photo', label: 'Фотография'},
    { id: 'types', label: 'Тип верификации'},
    { id: 'confirmation', label: 'Подтверждение'},
]

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.id,
            dates: getDate(+item.dates),
            login: item.login,
            description: item.description === 'undefined' ? '-' : item.description,
            photo: item.photo,
            types: getStatus(item.types)
        }
    })
} 

export {
    useStyles,
    columns,
    getRows
}